"use strict";
/****************************************************
 * Audit Information Platform Component
 * 包含树的参照项目组件
 * 2020-08
 * Sunny <tufpsj@yonyou.com>
 ****************************************************/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
//----- Global ------
var React = require("react");
//----- iUAP ------
var ref_tree_1 = require("ref-tree");
require("ref-tree/lib/index.css");
//----- AIP ------
var RefItem_1 = require("./RefItem");
require("../style/TreeRef.css");
var utils_1 = require("../utils");
/**
 * 树形组件
 *
 * 弹出表格组件
 *
 */
var TreeRef = /** @class */ (function (_super) {
    __extends(TreeRef, _super);
    function TreeRef() {
        /**
         * value: '{"refname":"用友集团","refpk":"001"}',
         * matchData: [{ name: '用友集团', refname: '用友集团', code: '001' }],
         *
         */
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: '',
            treeData: [],
            matchData: _this.props.matchData || [],
            oldData: [],
            defaultExpandedKeys: [],
        };
        /**
         * 当点击文本框右侧弹出按钮时是否打开modal适用于级联情况下当选择不全时的处理
         * @function
         */
        _this.canClickGoOn = function () {
            // this.loadData(); // 🐶 你为什么在这里还要请求一次？？？ 什么逻辑？？
            return true; //必须要有
        };
        /**
         * 将列表数据转换为树结构数据
         * @function
         *
         * @param {TreeItem[]} orgs
         * @returns {TreeData[]}
         */
        _this.processOrgs = function (orgs) {
            orgs.forEach(function (org) {
                org.refname = org[_this.props.displayfield];
                org.name = org[_this.props.displayfield];
                org.refpk = org[_this.props.valuefield];
                var childrens = org.children;
                if (childrens) {
                    _this.processOrgs(childrens);
                }
            });
            return orgs;
        };
        /**
         * 将树对象（包含子节点）列表转为一维列表
         * @function
         *
         * @param {TreeData[]} treeData
         * @returns {TreeItem[]}
         */
        _this._treeDataToFlat = function (treeData) {
            var result = [];
            function treeItemProcess(treeItems) {
                if (!treeItems || treeItems.length === 0)
                    return;
                treeItems.forEach(function (t) {
                    result.push(t);
                    if (t.children) {
                        treeItemProcess(t.children);
                    }
                });
            }
            treeData.forEach(function (treeItem) {
                result.push(treeItem);
                if (treeItem.children) {
                    treeItemProcess(treeItem.children);
                }
            });
            return result;
        };
        /**
         * 获取数据
         *
         * @function
         *
         * value: '{"refname":"xx集团;yy集团","refpk":"001;002"}',
         * matchData: [{ name: 'xx集团', refname: 'xx集团', code: '001' }, { name: 'yy集团', refname: 'yy集团', code: '002' }],
         *
         * treeData:
         * {
         *   name: 'xxx',
         *   refname: 'xxx',
         *   code: '001',
         *   refpk: '001',
         *   childrens: [
         *     {
         *       name, refname, code, refpkm
         *     },
         *     {}, ...
         *   ]
         * }
         *
         * @param {StringStringMap} params
         * @param {string} defaultValue
         */
        _this.loadData = function (params, defaultValue) {
            var _a;
            var treeData = [];
            var getData = _this.props.loadData;
            var refId = _this.props.refId || '';
            var itemIndex = (_a = _this.props.itemIndex) !== null && _a !== void 0 ? _a : -1;
            getData(refId, itemIndex, _this.props.dsId, params || {}).then(function (resp) {
                var results = resp;
                if (!results || !results.data.length) {
                    _this.setState({
                        loading: false,
                        pageCount: -1,
                        totalElements: 0,
                        treeData: treeData,
                    });
                    return false;
                }
                treeData = results.data;
                _this.processOrgs(treeData);
                var expandKeys = [];
                var getNextChildren = function (nodeChildren) {
                    if (nodeChildren.length === 1) {
                        var node = nodeChildren[0];
                        expandKeys.push(node.refpk);
                        if (node.children) {
                            getNextChildren(node.children);
                        }
                    }
                    else if (nodeChildren.length >= 1) {
                        nodeChildren.forEach(function (item) {
                            expandKeys.push(item.refpk);
                        });
                    }
                };
                if (treeData.length === 1) {
                    var node = treeData[0];
                    if (node.children) {
                        expandKeys.push(node.refpk);
                        getNextChildren(node.children);
                    }
                }
                else {
                    treeData.forEach(function (item) {
                        expandKeys.push(item.refpk);
                    });
                }
                var page = results.page;
                if (defaultValue) { // 如果有默认值，就设置相应属性
                    var values_1 = [];
                    try {
                        values_1 = defaultValue.split(',');
                    }
                    catch (e) {
                        console.log(e.message);
                    }
                    values_1 = values_1.map(function (val) {
                        if (val.startsWith("'")) {
                            return val.substring(1, val.length - 1);
                        }
                        return val;
                    });
                    var flatTreeData = _this._treeDataToFlat(treeData);
                    var matchs = (flatTreeData || []).filter(function (item) {
                        return values_1.includes(item[_this.props.valuefield]);
                    });
                    if (matchs.length > 0) {
                        _this.setState(__assign(__assign({ treeData: treeData }, page), { loading: false, matchData: matchs, value: utils_1.Utils.getShowFieldValues(matchs, _this.props.displayfield, _this.props.valuefield) }), function () {
                            _this.refItemValueChange(defaultValue);
                        });
                    }
                    else {
                        _this.setState(__assign(__assign({ treeData: treeData }, page), { loading: false, defaultExpandedKeys: expandKeys }));
                    }
                }
                else {
                    _this.setState(__assign(__assign({ treeData: treeData }, page), { loading: false, defaultExpandedKeys: expandKeys }));
                }
                // fetchCallback = (data, condition, url)
                setTimeout(function () {
                    _this.props.fetchCallback && _this.props.fetchCallback(treeData, params, refId, itemIndex);
                }, 200);
            }).catch(function (e) {
                console.error("error: ".concat(e.message));
            });
        };
        /**
         * 点击树组件的"确定"按钮触发时间
         * @function
         *
         * @param {any[]} results
         */
        _this.onSave = function (results) {
            if (window.isAipDebug) {
                console.log('onsave fired');
                console.log(results);
            }
            _this.valueChange(results);
        };
        /**
         * 将请求数据转为组件所需数据格式
         * @function
         *
         * @param {any[]} items
         */
        _this.buildValue = function (items) {
            var result = {};
            items.forEach(function (item) {
                var valueField = result['refpk'];
                if (!valueField) {
                    result['refpk'] = item['refpk'];
                }
                else {
                    result['refpk'] = result['refpk'] + ';' + item['refpk'];
                }
                var displayField = result['refname'];
                if (!displayField) {
                    result['refname'] = item['refname'];
                }
                else {
                    result['refname'] = result['refname'] + ';' + item['refname'];
                }
            });
            return result;
        };
        /**
         * 数据选择发生变化触发例程
         * @function
         *
         * @param {any[]} results
         */
        _this.valueChange = function (results) {
            // 通知其他关联的组件更新
            _this.setState({
                matchData: results,
            }, function () {
                _this.refItemValueChange(_this.getValue());
            });
        };
        /**
         * 获取值，按需 ***override***
         * @function
         *
         * @returns {string}
         */
        _this.getValue = function () {
            var result = [];
            if (_this.state.matchData) {
                _this.state.matchData.forEach(function (item) {
                    result.push(item[_this.props.valuefield]);
                });
            }
            if (_this.props.multiple === '0') {
                return result[0];
            }
            else if (_this.props.multiple === '1') {
                var tmp = result.map(function (item) {
                    return "'" + item + "'";
                });
                return tmp.join(',');
            }
            else {
                return result.join(',');
            }
        };
        /**
         * 重置值 **override**
         *
         * @function
         */
        _this.clear = function () {
            if (_this.props.itemIndex === 0) {
                _this.setState({
                    matchData: [],
                    value: "{\"refname\":\"\",\"refpk\":\"".concat(Math.random(), "\"}"),
                }, function () {
                });
            }
            else {
                _this.setState({
                    matchData: [],
                    oldData: [],
                    treeData: [],
                    value: "{\"refname\":\"\",\"refpk\":\"".concat(Math.random(), "\"}"),
                }, function () {
                });
            }
        };
        /**
         * 检索树
         * @function
         *
         * @param {string} value
         */
        _this.onSearch = function (value) {
            _this.getRefTreeData(value, true);
        };
        /**
         * 匹配给定值的树节点数据
         * @function
         *
         * @param {string} value
         * @param {boolean} flag 可选参数
         */
        _this.getRefTreeData = function (value, flag) {
            var doAction = window.event['keyCode'] === 13;
            if (!doAction) {
                try {
                    doAction = window.event.target.className === 'uf uf-search';
                }
                catch (e) {
                    doAction = false;
                }
            }
            if (doAction) {
                if (value === '') {
                    var data = _this.state.oldData;
                    if (data.length !== 0) {
                        _this.setState({
                            treeData: data,
                            oldData: []
                        });
                    }
                }
                else {
                    var data = JSON.parse(JSON.stringify(_this.state.treeData));
                    if (_this.state.oldData.length === 0) {
                        _this.setState({
                            oldData: JSON.parse(JSON.stringify(data))
                        });
                    }
                    else {
                        data = JSON.parse(JSON.stringify(_this.state.oldData));
                    }
                    var originData = JSON.parse(JSON.stringify(data));
                    data = _this.filterTree(value, data, originData, 0);
                    _this.setState({
                        treeData: data
                    });
                }
            }
        };
        _this.getExtExpandKey = function () {
            var data = _this.state.oldData;
        };
        /**
         * 树数据过滤例程
         * @function
         *
         * @param {string} value
         * @param {any[]} data
         * @param {any[]} originData
         * @param {number} level
         */
        _this.filterTree = function (value, data, originData, level) {
            var arr = [];
            for (var i = 0; i < data.length; i++) {
                var item = data[i];
                var copyItem = JSON.parse(JSON.stringify(item));
                delete copyItem.children;
                if (item.children && item.children.length !== 0) {
                    var childData = item.children;
                    var childrenData = _this.filterTree(value, childData, originData[i].children, level + 1);
                    if (childrenData.length === 0) {
                        var flag = item.name.indexOf(value) >= 0;
                        if (flag) {
                            copyItem['children'] = childData;
                            arr.push(copyItem);
                        }
                    }
                    else {
                        copyItem['children'] = childrenData;
                        arr.push(copyItem);
                    }
                }
                else {
                    if (level !== 0) {
                        var flag = item.name.indexOf(value) >= 0;
                        if (flag) {
                            arr.push(item);
                        }
                    }
                    else {
                        if (item.name.indexOf(value) >= 0) {
                            arr.push(copyItem);
                        }
                    }
                }
                if (i === data.length - 1) {
                    return arr;
                }
            }
            var result = [];
            arr.forEach(function (item) {
                if (item.children && item.children.length !== 0) {
                    result.push(item);
                }
                if (!item.children) {
                    result.push(item);
                }
            });
            return result;
        };
        _this.handlerShow = function () {
            var height = _this.props.modalHeight;
            if (height) {
                var treeDom = document.querySelector(".ref-core-tree");
                if (treeDom) {
                    treeDom.setAttribute("style", "height:".concat(height, "px"));
                }
            }
        };
        _this.handleTreeSelect = function (selectedNode) {
            _this.setState({
                matchData: selectedNode
            });
        };
        _this.handleExpand = function (expandedKeys) {
            _this.setState({
                defaultExpandedKeys: expandedKeys
            });
        };
        return _this;
    }
    TreeRef.prototype.render = function () {
        var _this = this;
        var _a = this.state, treeData = _a.treeData, matchData = _a.matchData, value = _a.value;
        var modelProps = {
            width: 400,
            draggable: true,
            onShow: this.handlerShow,
            needScroll: true
        };
        if (this.props.modalWidth) {
            modelProps.width = this.props.modalWidth;
        }
        var treeProps = {
            defaultExpandedKeys: this.state.defaultExpandedKeys,
            onExpand: this.handleExpand,
        };
        return (React.createElement(ref_tree_1.RefTreeWithInput, { className: 'clannad', style: { width: this.props.width || 200 }, searchable: true, emptyBut: true, nodeDisplay: function (record) {
                return record.name;
            }, modalProps: modelProps, defaultExpandAll: false, treeProps: treeProps, backdrop: this.props.backDrop, dropdownDisabled: true, displayField: function (record) {
                return record[_this.props.displayfield];
            }, valueField: this.props.valuefield, multiple: this.props.multiple !== '0', onSave: this.onSave, matchData: matchData, onTreeSelecting: this.handleTreeSelect, checkStrictly: !this.props.cascadeChecked, treeData: treeData, title: (0, utils_1.getTranslate)(null, this.props.label || this.props.name), canClickGoOn: this.canClickGoOn, isLocalSearch: false, getRefTreeData: this.getRefTreeData, value: value }));
    };
    return TreeRef;
}(RefItem_1.default));
exports.default = TreeRef;
